import { render, staticRenderFns } from "./index.vue?vue&type=template&id=151f0a78&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=151f0a78&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../ui/comic_ai/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "151f0a78",
  null
  
)

export default component.exports